module.exports = __webpack_public_path__ + "img/sp_article_6.cb64776c.jpg";